import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'percent', standalone: true })
export class PercentPipe implements PipeTransform {
  private readonly numberPipe: DecimalPipe;

  public constructor(@Inject(LOCALE_ID) localeId: string) {
    this.numberPipe = new DecimalPipe(localeId);
  }

  public transform(value?: number | null): string {
    const positive = value != null ? value > 0 : false;
    const percent = value != null ? this.numberPipe.transform(value, '1.0-0') : null;
    return percent ? `${positive ? '+' : ''}${percent}%` : '-';
  }
}
